/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable prefer-template */
/* eslint-disable no-constant-condition */
import React, {
  forwardRef,
  RefObject,
  useCallback,
  useEffect,
  useState,
  useRef,
} from 'react';
import ModalEdgeCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalEdgeCloseBtn';
import ItemsGrid from '@wconcept/wconcept-ui-renewal/components/atoms/ItemsGrid';
import ModalCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalCloseBtn';
import ModalTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ModalTitle';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Box from '@wconcept/wconcept-ui-renewal/components/atoms/Box';
import BasicBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/BasicBtn';
import { IconRefresh03 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import * as S from './style';

interface IProps {
  onClose?: () => void;
  isError?: boolean;
  value: {
    isErr: boolean;
    className?: string;
    refetch: () => void;
    items: React.ReactNode[];
    isDesktop: boolean;
    isNetworkError: boolean;
    isIPhoneXApp: boolean;
    contentRef?: RefObject<HTMLDivElement>;
    type?: 'shortform' | undefined;
  };
}

const RelatedPrdModal = forwardRef<HTMLDivElement, IProps>(
  ({ onClose, value, isError }, ref) => {
    const {
      items,
      isDesktop,
      contentRef,
      isErr,
      refetch,
      type,
      isNetworkError,
    } = value;
    const [hasScroll, setHasScroll] = useState(false);
    const contentAreaRef = useRef<HTMLDivElement>(null);

    const [useError, setUseError] = useState(false);

    useEffect(() => {
      setUseError(isErr || isError || isNetworkError || false);
    }, [isErr, isError, isNetworkError]);

    const checkForScroll = useCallback(() => {
      if (contentRef?.current || contentAreaRef?.current) {
        const { scrollHeight, clientHeight } =
          contentRef?.current || (contentAreaRef.current as HTMLDivElement);
        setHasScroll(scrollHeight > clientHeight);
      }
    }, [contentRef]);

    useEffect(() => {
      checkForScroll();
      window.addEventListener('resize', checkForScroll);

      return () => {
        window.removeEventListener('resize', checkForScroll);
      };
    }, [checkForScroll, items]);

    const handleClose = useCallback(() => {
      onClose?.();
    }, [onClose]);

    return (
      <S.RelatedPrdModal
        className={`relatedPrd-modal ${type}` ? 'type-' + type : ''}
      >
        {isDesktop ? (
          <>
            <ModalCloseBtn onClick={handleClose} />
            <ModalTitle title="관련상품" />
          </>
        ) : (
          <ModalEdgeCloseBtn onClick={handleClose} />
        )}
        <div
          ref={contentRef || ref || contentAreaRef}
          className={`content${hasScroll ? ' is-scroll' : ''}`}
        >
          {!useError ? (
            <ItemsGrid
              perView={isDesktop ? (type === 'shortform' ? 3 : 5) : 3}
              colGap={6}
              rowGap={24}
            >
              {items}
            </ItemsGrid>
          ) : (
            <Box className="error-box">
              {isNetworkError ? (
                <Text>
                  네트워크 연결이 원활하지 않습니다.
                  <br />
                  연결 상태를 확인해 주세요.
                </Text>
              ) : (
                <Text>
                  현재 서비스 접속이 원활하지 않습니다.
                  <br />
                  이용에 불편을 드려 죄송합니다.
                </Text>
              )}
              <BasicBtn
                className="btn-more"
                beforeIcon={<IconRefresh03 />}
                text="다시 시도하기"
                onClick={async () => {
                  refetch?.();
                }}
              />
            </Box>
          )}
        </div>
      </S.RelatedPrdModal>
    );
  }
);
RelatedPrdModal.displayName = 'RelatedPrdModal';
export default RelatedPrdModal;
